import { Fragment, h } from "preact";
import { useContext, useState } from "preact/hooks";

import { Context } from "./lib/globalState";

import SingleComment from "./components/SingleComment";
import AllComments from "./components/AllComments";
import LoginModal from "./components/LoginModal";
import UserInfoModal from "./components/UserInfoModal";

export default function App() {
  const {
    state: { sharedCommentId, userInfoVisible, loginVisible, comment },
  } = useContext(Context);

  const [visible, setVisible] = useState(false);

  // If comment is false in widget settings
  if (!comment) {
    return null;
  }

  // Else Comment is true
  if (!sharedCommentId || visible) {
    return (
      <Fragment>
        <AllComments visible={visible} setVisible={setVisible} />
        {/* Login Modal */}
        {loginVisible && <LoginModal />}

        {/* UserInfo Modal */}
        {userInfoVisible && <UserInfoModal />}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <SingleComment setVisible={setVisible} />
      {/* Login Modal */}
      {loginVisible && <LoginModal />}

      {/* UserInfo Modal */}
      {userInfoVisible && <UserInfoModal />}
    </Fragment>
  );
}
